module.exports = __webpack_public_path__ + "img/time.b5e72ff9.png";